<template>
	<div class="col edit-layout" gutter="20">
		<div>
			<slot />
		</div>
		<div class="col" align-x="right" gutter="10">
			<span class="color-danger">* 填寫完請記得按儲存，否則資料會不見喔！</span>
			<div class="row">
				<div class="cancel-btn button-tp color-white bg-text4" @click="$emit('cancel')">取消</div>
				<div class="save-btn button-tp color-white bg-green1" @click="$emit('save')">儲存</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	}
};
</script>

<style lang="scss">
.edit-layout {
	.save-btn {
		width: 149px;
		height: 30px;
	}

	.cancel-btn {
		width: 149px;
		height: 30px;
		margin-right: 15px;
	}
}
</style>
